import React from "react";
import { EXAM_TYPE_COLORS } from "../../utils/examsschedule/examConstants";
import { Badge } from "../../components/ui";

export default function ExamTypeBadge({ type, name }) {
  const cls = EXAM_TYPE_COLORS[type] || "bg-neutral-100 dark:bg-neutral-800 text-neutral-800 dark:text-neutral-100";
  const label = name || (type || "—").replace(/_/g, " ");
  return (
    <Badge className={`text-[10px] font-semibold px-2 py-0.5 border-0 ${cls}`}>
      {label}
    </Badge>
  );
}